import { render, staticRenderFns } from "./UpdateCustomerSampleOrderPopUp.vue?vue&type=template&id=28aa394e&scoped=true&"
import script from "./UpdateCustomerSampleOrderPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerSampleOrderPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerSampleOrderPopUp.vue?vue&type=style&index=0&id=28aa394e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aa394e",
  null
  
)

export default component.exports